import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DossierTermination } from "../../types/Dossier";

export const setDriverNotifiedOfTermination = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    optimisiticUpdateOnMutate,
    getDataByQueryKey,
  } = useAPQuery();

  return useMutation({
    mutationFn: (): Promise<boolean> => {
      return fetchWithAuth<boolean>(
        "setDriverNotifiedOfTermination",
        dossierId,
        {
          requestOptions: { method: "post" },
        }
      );
    },
    onMutate: async () => {
      const queryKey = ["employerDossierTermination", dossierId];
      const dossierTermination = getDataByQueryKey(
        queryKey
      ) as DossierTermination;
      const updatedDossierTermination = {
        ...dossierTermination,
        driverNotifiedOfTermination: true,
      };

      optimisiticUpdateOnMutate(
        ["employerDossierTermination", dossierId],
        updatedDossierTermination
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
